/* eslint-disable @typescript-eslint/naming-convention */
import { AUTHORISATION_RIGHT } from './authorisation-rights.const';
import { Palette } from './palette';
import { BackgroundType, CustomImage, Font } from './style';

export const GameMainImages = [
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/pink-blue.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/multicolor-1.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/blue.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/purple.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/sepia.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/dots.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/lines.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/squares.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/stripes.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/woven.jpg',
    alt: '',
  },
];

export const GamePortraitImages = [
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/avatar/full-1.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/avatar/full-2.jpg',
    alt: '',
  },
  { type: BackgroundType.IMAGE, src: './assets/shared/images/game-background/avatar/full-3.jpg', alt: '' },
  { type: BackgroundType.IMAGE, src: './assets/shared/images/game-background/avatar/full-4.jpg', alt: '' },
  { type: BackgroundType.IMAGE, src: './assets/shared/images/game-background/avatar/shape-1.jpg', alt: '' },
  { type: BackgroundType.IMAGE, src: './assets/shared/images/game-background/avatar/shape-2.jpg', alt: '' },
  { type: BackgroundType.IMAGE, src: './assets/shared/images/game-background/avatar/shape-3.jpg', alt: '' },
  { type: BackgroundType.IMAGE, src: './assets/shared/images/game-background/avatar/shape-4.jpg', alt: '' },
  { type: BackgroundType.IMAGE, src: './assets/shared/images/game-background/avatar/ink-1.jpg', alt: '' },
  { type: BackgroundType.IMAGE, src: './assets/shared/images/game-background/avatar/ink-2.jpg', alt: '' },
  { type: BackgroundType.IMAGE, src: './assets/shared/images/game-background/avatar/ink-3.jpg', alt: '' },
  { type: BackgroundType.IMAGE, src: './assets/shared/images/game-background/avatar/ink-4.jpg', alt: '' },
];

export const GameSounds = [
  {
    src: 'assets/games-assets/sound/playerv2/ambiance_1.mp3',
  },
  {
    src: 'assets/games-assets/sound/playerv2/ambiance_2.mp3',
  },
  {
    src: 'assets/games-assets/sound/playerv2/ambiance_3.mp3',
  },
  {
    src: 'assets/games-assets/sound/playerv2/ambiance_4.mp3',
  },
  {
    src: 'assets/games-assets/sound/playerv2/ambiance_5.mp3',
  },
];

export const Palettes: Palette[] = [
  {
    name: 'grapefruit',
    primaryColor: '#E4595B',
    darkColor: '#173640',
    lightColor: '#ffffff',
  },
  {
    name: 'turquoise',
    primaryColor: '#43AE97',
    darkColor: '#000000',
    lightColor: '#ffffff',
  },
  {
    name: 'ocean',
    primaryColor: '#0091D8',
    darkColor: '#000000',
    lightColor: '#ffffff',
  },
  {
    name: 'space',
    primaryColor: '#5395e4',
    darkColor: '#0E344D',
    lightColor: '#FFFFFF',
  },
  {
    name: 'grape',
    primaryColor: '#970A82',
    darkColor: '#242424',
    lightColor: '#EFEBEB',
  },
  {
    name: 'purple',
    primaryColor: '#7660E9',
    darkColor: '#000000',
    lightColor: '#FFFFFF',
  },
  {
    name: 'fuchsia',
    primaryColor: '#BE3DE8',
    darkColor: '#000000',
    lightColor: '#FFFFFF',
  },
  {
    name: 'pink',
    primaryColor: '#D74C7B',
    darkColor: '#000000',
    lightColor: '#FFFFFF',
  },
  {
    name: 'red-poppy',
    primaryColor: '#FF4D4E',
    darkColor: '#000000',
    lightColor: '#FFFFFF',
  },
  {
    name: 'green-apple',
    primaryColor: '#45A11A',
    darkColor: '#242424',
    lightColor: '#EFEBEB',
  },
  {
    name: 'jungle',
    primaryColor: '#51C859',
    darkColor: '#1C5D4F',
    lightColor: '#F5F4F0',
  },
  {
    name: 'kiwi',
    primaryColor: '#8DC10B',
    darkColor: '#000000',
    lightColor: '#FFFFFF',
  },
  {
    name: 'gold',
    primaryColor: '#E5C402',
    darkColor: '#000000',
    lightColor: '#ffffff',
  },
  {
    name: 'honey',
    primaryColor: '#F3A025',
    darkColor: '#000000',
    lightColor: '#ffffff',
  },
  {
    name: 'peach',
    primaryColor: '#F96E3E',
    darkColor: '#000000',
    lightColor: '#ffffff',
  },
  {
    name: 'grey',
    primaryColor: '#9B9B9B',
    darkColor: '#000000',
    lightColor: '#ffffff',
  },
];

export const Fonts = [
  {
    family: 'Inter',
    ratio: 1,
    letterSpacing: 0,
  },
  {
    family: 'DM Sans',
    ratio: 1,
    letterSpacing: 0,
  },
  {
    family: 'Montserrat',
    ratio: 1,
    letterSpacing: 1,
  },
  {
    family: 'Ubuntu',
    ratio: 1.1,
    letterSpacing: 0,
  },
  {
    family: 'Roboto Condensed',
    ratio: 1.1,
    letterSpacing: 0,
  },
  {
    family: 'Roboto',
    ratio: 1,
    letterSpacing: 0,
  },
  {
    family: 'Comfortaa',
    ratio: 1,
    letterSpacing: 0,
  },
  {
    family: 'Amaranth',
    ratio: 1.2,
    letterSpacing: 0,
  },
  {
    family: 'Arvo',
    ratio: 1,
    letterSpacing: 0,
  },
  {
    family: 'Kreon',
    ratio: 1.2,
    letterSpacing: 0,
  },
  {
    family: 'Ruda',
    ratio: 1.1,
    letterSpacing: 0,
  },
  {
    family: 'Solway',
    ratio: 1.2,
    letterSpacing: 0,
  },
].map(f => new Font(f));

export const BackgroundPatternImages: CustomImage[] = [
  {
    type: BackgroundType.LOTTIE,
    alt: 'vertex',
    src: './assets/shared/lotties/LOTTIE_VERTEX_01.json',
    // no rights normal???
  },
  {
    type: BackgroundType.LOTTIE,
    alt: 'circle',
    src: './assets/shared/lotties/LOTTIE_CIRCLE.json',
    right: [AUTHORISATION_RIGHT.JUMP, AUTHORISATION_RIGHT.BIZNESS],
  },
  {
    type: BackgroundType.IMAGE,
    alt: 'squares',
    src: './assets/shared/images/menu-background/squares.jpg',
  },
  {
    type: BackgroundType.IMAGE,
    alt: 'dots',
    src: './assets/shared/images/menu-background/dots.jpg',
  },
  {
    type: BackgroundType.IMAGE,
    alt: 'lines',
    src: './assets/shared/images/menu-background/lines.png',
  },
  {
    type: BackgroundType.IMAGE,
    alt: 'stripes',
    src: './assets/shared/images/menu-background/stripes.png',
  },
  {
    type: BackgroundType.IMAGE,
    alt: 'woven',
    src: './assets/shared/images/menu-background/woven.jpg',
  },
];

export const BackgroundImages: CustomImage[] = [
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/main-background/univers.jpg',
    alt: 'univers',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/main-background/nature.jpg',
    alt: 'nature',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/main-background/desk.jpg',
    alt: 'desk',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/main-background/desk-red.jpg',
    alt: 'desk',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/main-background/desk-blue.jpg',
    alt: 'desk',
  },
  {
    type: BackgroundType.LOTTIE,
    src: './assets/shared/lotties/LOTTIE_PLANTE.json',
    alt: 'plante',
    right: [AUTHORISATION_RIGHT.JUMP, AUTHORISATION_RIGHT.BIZNESS],
  },
];

export const FaviconImages: CustomImage[] = [
  {
    type: BackgroundType.IMAGE,
    alt: 'squares',
    src: './assets/shared/images/branding/favicon-squares.svg',
  },
  {
    type: BackgroundType.IMAGE,
    alt: 'bizness',
    src: './assets/shared/images/branding/favicon-z.svg',
  },
];

export const SlideBackgrounds: CustomImage[] = [
  {
    type: BackgroundType.LOTTIE,
    alt: 'vertex',
    src: './assets/shared/lotties/LOTTIE_VERTEX_01.json',
    // no rights normal???
  },
  {
    type: BackgroundType.LOTTIE,
    alt: 'circle',
    src: './assets/shared/lotties/LOTTIE_CIRCLE.json',
    right: [AUTHORISATION_RIGHT.JUMP, AUTHORISATION_RIGHT.BIZNESS],
  },
  {
    type: BackgroundType.LOTTIE,
    alt: 'minigame',
    src: './assets/shared/lotties/lottie_minigame.json',
    right: [AUTHORISATION_RIGHT.JUMP, AUTHORISATION_RIGHT.BIZNESS],
  },
  {
    type: BackgroundType.LOTTIE,
    alt: 'minigame2',
    src: './assets/shared/lotties/lottie_minigame_2.json',
    right: [AUTHORISATION_RIGHT.JUMP, AUTHORISATION_RIGHT.BIZNESS],
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/slide-background/desk.jpg',
    alt: 'desk',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/slide-background/desk-red.jpg',
    alt: 'desk',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/slide-background/nature.jpg',
    alt: 'desk',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/slide-background/univers.jpg',
    alt: 'desk',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/dots.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/lines.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/squares.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/stripes.jpg',
    alt: '',
  },
  {
    type: BackgroundType.IMAGE,
    src: './assets/shared/images/game-background/pattern/woven.jpg',
    alt: '',
  },
];
